@if(componentModel){
    <article class="relative  min-w-72 isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-8 pt-80 sm:pt-48 lg:pt-80">
        <img loading="lazy"  [src]="componentModel?.image?.value" class="absolute inset-0 -z-10 size-full object-cover" [alt]="componentModel.title.value">
        <div class="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
        <div class="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10"></div>
        <div class="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm/6 text-gray-300">
            @if(componentModel?.metaData?.value){
                <time datetime="2020-03-16" class="mr-8">{{componentModel?.metaData?.value}}</time>
            }
            <div class="-ml-4 flex items-center gap-x-4">
                <svg viewBox="0 0 2 2" class="-ml-0.5 size-0.5 flex-none fill-white/50">
                    <circle cx="1" cy="1" r="1" />
                </svg>
                <div class="flex gap-x-2.5">
                    {{componentModel?.description?.value}}
                </div>
            </div>
        </div>
        <h3 class="mt-3 text-lg/6 font-semibold text-white">
            <a [attr.href]="componentModel?.link?.value || null">
                <span class="absolute inset-0"></span>
                {{componentModel?.title?.value}}
            </a>
        </h3>
    </article>

}

